import api from "./Api";

class ConfiguracaoService {
  GetConfiguracao(payload) {
    return api.get("/v1/configuracao/" + payload).then((response) => {
      return response.data;
    });
  }

  PostConfiguracao(payload) {
    return api.post("/v1/configuracao/", payload).then((response) => {
      return response.data;
    });
  }

  PutConfiguracao(payload) {
    return api.put("/v1/configuracao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteConfiguracao(payload) {
    return api.delete("/v1/configuracao/" + payload).then((response) => {
      return response.data;
    });
  }

  GetConfiguracaoOData(payload) {
    return api.get("/OData/Configuracao" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ConfiguracaoService();
